import useLive from './useLive';
import useOrgSwitchChannel from './useOrgSwitchChannel';

const Observer = () => {
  useLive();
  useOrgSwitchChannel({ listen: true });
};

export default Observer;
